import _ from "lodash"
import $router from "../common/uni-router"
import { Volcengine } from "../common"
export default class UniVolcengine extends Volcengine {
  constructor(params) {
    params.type = 0 // 表示是uni-app 端的SDK
    super(params)
    try {
      this.uniPluginObject = params.uniPluginObject
      this.routerInfo = UNI_ROUTES.pages
      this.tarBar = UNI_ROUTES.tarBar ? UNI_ROUTES.tarBar.list : []
      this.isVolcengine = true
      if (!this.uniPluginObject.hasStarted()) {
        this.uniPluginObject.start()
      }
    } catch (e) {
      this.isVolcengine = false
      this.routerInfo = []
      this.tarBar = []
    }
    this.isIOSWebviewPause = false
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
  }
  start() {
    if (!this.isVolcengine) {
      return
    }
    this.init(this.routerInfo, this.tarBar)
  }
  // 监听路由变化
  listenRouter(param) {
    if (!_.isObject(param)) {
      param = {}
    }
    $router.onchange = (n, o) => {
      if (!this.isVolcengine) {
        return
      }
      try {
        const lastVisitUrl = this.getCacheVisitUrl()
        const nowPath = n.fullPath
        if (lastVisitUrl === nowPath) {
          return
        }
        this.setCacheVisitUrl(nowPath)
        this.customPageview(o.fullPath, param)
      } catch (e) {}
    }
  }
  /**
   * 上报火山引擎唯一的用户id 登录传id 退出的时候传null或空字符串
   * @param {*} paramUserUniqueId 要上报的火山用户唯一ID
   * @returns
   */
  setUserUniqueId(paramUserUniqueId) {
    if (!this.isVolcengine) {
      return
    }
    const userUniqueId = paramUserUniqueId || this.nullProp
    try {
      this.uniPluginObject.setUserUniqueId(userUniqueId)
    } catch (e) {}
  }
  // 获取uni-app的插件
  getuniPluginObject() {
    return this.uniPluginObject
  }
  // 获取项目是否接入了火山SDK
  getIsVolcengine() {
    return this.isVolcengine
  }
  /**
   * 上报接口埋点
   * @param {Object} param
   */
  collectApi(param) {
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
    const currentUrl = this.pages[0]
    const commonAttr = this.getCommonAttr(currentUrl)
    const apiParam = {
      api_name: param.apiName, // 接口名称
      is_success: param.isSuccess, // 是否成功
      api_time_cost: param.apiTimeCost // 接口请求耗费的时间
    }
    let finalParam = {
      ...commonAttr,
      ...apiParam
    }
    delete param.apiName
    delete param.isSuccess
    delete param.apiTimeCost
    finalParam = {
      ...finalParam,
      ...param
    }
    try {
      this.uniPluginObject.onEventV3("api_request", finalParam)
    } catch (e) {}
  }

  /**
   *
   * @param {*} path 路径
   * @param {*} param 用户自定义的参数
   */
  customPageview(path, param) {
    if (!this.volcengineProps[path]) {
      this.updateRouter(this.routerInfo, this.tarBar)
    }
    const lastPageVisitTime = this.getCacheTime()
    const nowTime = new Date().getTime()
    this.setCacheTime(nowTime)
    const commonAttr = this.getCommonAttr(path)
    const durationParam = {
      custom_page_duration: nowTime - lastPageVisitTime
    }
    const finalParam = {
      ...commonAttr,
      ...durationParam,
      ...param
    }
    this.uniPluginObject.onEventV3("custom_pageview", finalParam)
  }
  // 监听初始化进入页面
  customPageviewOpen(param) {
    if (!_.isObject(param)) {
      param = {}
    }
    try {
      // 是否是用vebview打开了H5，如果打开了，则不触发Open
      const webviewVisible = this.checkVebviewVisible()
      if (webviewVisible) {
        return
      }
      const nowTime = new Date().getTime()
      this.setCacheTime(nowTime) // 重新记录页面停留时间
      let currentUrl
      if (this.pages.length > 0) {
        currentUrl = this.pages[0]
      } else {
        // 获取不到当前页面只能获取上一次访问的
        currentUrl = this.getCacheVisitUrl()
      }
      // 如果没有任何匹配的，那就是首页
      if (!currentUrl) {
        currentUrl = "/" + this.routerInfo[0].path
      }
      this.setCacheVisitUrl(currentUrl)
      if (!this.volcengineProps[currentUrl]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }

      const commonAttr = this.getCommonAttr(currentUrl)
      const finalParam = {
        ...commonAttr,
        ...param
      }
      this.uniPluginObject.onEventV3("custom_pageview_open", finalParam)
    } catch (e) {
    }
  }

  handleWebviewOnHide() {
    try {
      // 是否是iOS
      const agent = plus.navigator.getUserAgent()
      const isIOS = agent.match(/(iphone os)/i) // iOS终端
      const nowTime = new Date().getTime()
      this.setCacheTime(nowTime)
      if (isIOS) {
        const webwiewCache = this.getWebviewCache()
        const lastPageVisitTime = webwiewCache[this.cacheTimeKey] || 0
        delete webwiewCache[this.cacheTimeKey]
        const duration = nowTime - lastPageVisitTime
        const durationParam = {
          custom_page_duration: duration
        }
        const param = {
          ...webwiewCache,
          ...durationParam
        }
        this.uniPluginObject.onEventV3("custom_pageview", param)
        if (this.isIOSWebviewPause) {
          this.uniPluginObject.onEventV3("custom_pagview_hide", webwiewCache)
        }
      }
    } catch (e) {
    }
  }
  /**
   * 监听隐藏页面
   * @param
   * @returns
   */
  customPageviewHide(param) {
    try {
      const isWebviewHide = this.checkVebviewVisible()
      if (isWebviewHide) {
        const agent = plus.navigator.getUserAgent()
        const isIOS = agent.match(/(iphone os)/i) // iOS终端
        if (isIOS) {
          this.isIOSWebviewPause = true
          this.handleWebviewOnHide()
        }
        return
      }
      if (!_.isObject(param)) {
        param = {}
      }
      const pages = this.getCurrentPagesArr()
      this.changeCurrentPage(pages)
      let currentUrl = this.getCacheVisitUrl()
      if (this.pages.length > 0) {
        currentUrl = this.pages[0]
      }
      // 如果没有任何匹配的，那就是首页
      if (!currentUrl) {
        currentUrl = "/" + this.routerInfo[0].path
      }

      if (!this.volcengineProps[currentUrl]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }
      const commonAttr = this.getCommonAttr(currentUrl)
      const finalParam = {
        ...commonAttr,
        ...param
      }
      this.uniPluginObject.onEventV3("custom_pageview_hide", finalParam)
      // 上报当前页面的停留时间，然后onShow的时候会重新改写当前页面访问时间
      this.customPageview(currentUrl, param)
    } catch (e) {
    }
  }
  /**
   * 用户上报火山自定义事件
   * @param {*} name 自定义的事件名称
   * @param {*} param 自定义的事件参数
   * @returns
   */
  reportEvent(name, param) {
    // 防止 自定义 custom_pageview 事件的时候没有执行对应逻辑
    const oldPath =
      this.pages && this.pages.length ? this.pages[0] : this.routerInfo[0].path
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
    const currentUrl = this.pages[0]
    if (name === "custom_pageview") {
      this.setCacheVisitUrl(oldPath, param)
    }
    const commonAttr = this.getCommonAttr(currentUrl)
    const finalParam = {
      ...commonAttr,
      ...param
    }
    try {
      this.uniPluginObject.onEventV3(name, finalParam)
    } catch (e) {}
  }
  /**
   * 设置用户属性
   * @param {*} profileParam 用户属性
   * @returns
   */
  profileSet(profileParam) {
    try {
      this.uniPluginObject.profileSet(profileParam)
    } catch (e) {}
  }
  sdkVersionProfileSet(param) {
    try {
      const sdkVersion = this.getSdkVersion()
      const finalParam = {
        ...param,
        ...sdkVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }

  appVersionProfileSet(param) {
    try {
      const appVersion = this.getAppVersion()
      const finalParam = {
        ...param,
        ...appVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }

  // 判断是否有加载webview 以及 webivew 是否可见
  checkVebviewVisible() {
    let visible = false
    const webviewList = plus.webview.getDisplayWebview()
    if (webviewList.length) {
      const reg = /http[s]?:\/\/[\w.]+[\w\/]*[\w.]*\??[\w=&\+\%]*/
      webviewList.filter((item) => {
        return reg.test(item.getURL()) && item.isVisible()
      })
      visible = webviewList.length > 0
    }
    return visible
  }
}
